import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';
import { Flex } from './Flex';

const OverlayFlex = styled(Flex)`
  & {
    background-color: ${({ theme }) => theme.colors.whites[4]};
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    min-height: 300px;
    position: absolute;
    z-index: 1200;
  }
`;

const Loading = ({ spinnerLocation = 'center' }) => {
  const marginTop = spinnerLocation === 'top' ? '130px' : '0'; // 300px / 2 - 40px / 2, where 40px is the height of the spinner
  return (
    <OverlayFlex
      data-testid="loading"
      alignItems={spinnerLocation}
      justifyContent="center"
    >
      <CircularProgress style={{ marginTop }} />
    </OverlayFlex>
  );
};

export default Loading;
